// 3D board-icon set (56 icons, Airbnb-style)
// Files live in /app/frontend/public/board-icons/<slug>.png
// board.emoji stores either a legacy unicode emoji (e.g. "🏠") or the sentinel
// value "icon:<slug>" pointing at one of the images below.

import React from "react";

export const BOARD_ICONS = [
  { slug: "house",           label: "Casa" },
  { slug: "building",        label: "Palazzo" },
  { slug: "pin",             label: "Pin posizione" },
  { slug: "globe",           label: "Globo" },
  { slug: "target",          label: "Bersaglio" },
  { slug: "bookmark",        label: "Segnalibro" },
  { slug: "star",            label: "Stella" },
  { slug: "flame",           label: "Fiamma" },
  { slug: "lightbulb",       label: "Idea" },
  { slug: "lightning",       label: "Fulmine" },
  { slug: "rocket",          label: "Razzo" },
  { slug: "sun",             label: "Sole" },
  { slug: "chart",           label: "Grafico" },
  { slug: "money-bag",       label: "Sacco di denaro" },
  { slug: "wallet",          label: "Portafogli" },
  { slug: "book",            label: "Libro" },
  { slug: "folder",          label: "Cartella" },
  { slug: "box",             label: "Pacco" },
  { slug: "download",        label: "Download" },
  { slug: "chain",           label: "Collegamento" },
  { slug: "shield",          label: "Scudo/Sicurezza" },
  { slug: "gear",            label: "Impostazioni" },
  { slug: "wrench",          label: "Chiave inglese" },
  { slug: "pencil",          label: "Matita" },
  { slug: "pencil-2",        label: "Matita (variante)" },
  { slug: "search",          label: "Lente" },
  { slug: "printer",         label: "Stampante" },
  { slug: "envelope",        label: "Busta / Email" },
  { slug: "chat",            label: "Chat" },
  { slug: "bell",            label: "Notifiche" },
  { slug: "phone",           label: "Smartphone" },
  { slug: "monitor",         label: "Monitor" },
  { slug: "desktop-setup",   label: "Postazione desktop" },
  { slug: "keyboard",        label: "Tastiera" },
  { slug: "camera",          label: "Fotocamera" },
  { slug: "microphone",      label: "Microfono" },
  { slug: "headphones",      label: "Cuffie" },
  { slug: "speaker",         label: "Speaker" },
  { slug: "music-note",      label: "Nota musicale" },
  { slug: "play",            label: "Play" },
  { slug: "clock",           label: "Orologio" },
  { slug: "hourglass",       label: "Clessidra" },
  { slug: "car",             label: "Auto" },
  { slug: "airplane",        label: "Aereo" },
  { slug: "umbrella",        label: "Ombrello" },
  { slug: "coffee",          label: "Caffè" },
  { slug: "wine",            label: "Vino" },
  { slug: "hookah",          label: "Narghilè" },
  { slug: "football",        label: "Football" },
  { slug: "ai-chip",         label: "AI chip" },
  { slug: "floppy",          label: "Floppy / Salva" },
  { slug: "trash",           label: "Cestino" },
  { slug: "user",            label: "Utente" },
  { slug: "contact-card",    label: "Profilo" },
  { slug: "thumbs-up",       label: "Approvato" },
  { slug: "dots",            label: "Altro" },
];

export const ICON_PREFIX = "icon:";
export const isBoardIconValue = (v) => typeof v === "string" && v.startsWith(ICON_PREFIX);
export const iconSlug = (v) => (isBoardIconValue(v) ? v.slice(ICON_PREFIX.length) : "");
export const iconUrl = (slug) => `/board-icons/${slug}.png`;

/**
 * Renders a board icon: either the 3D PNG (when value = "icon:slug") or the
 * legacy unicode emoji. When value is empty we default to the "house" PNG
 * (Airbnb-style) so freshly created boards get a real icon instead of the
 * bland placeholder.
 */
export const BoardIcon = ({ value, size = 24, className = "", fallback = "icon:house", title }) => {
  const effective = value || fallback;
  if (isBoardIconValue(effective)) {
    return (
      <img
        src={iconUrl(iconSlug(effective))}
        alt={title || iconSlug(effective)}
        width={size}
        height={size}
        className={`inline-block object-contain align-middle ${className}`}
        style={{ width: size, height: size }}
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }
  return (
    <span
      className={`inline-block align-middle leading-none ${className}`}
      style={{ fontSize: Math.round(size * 0.85), lineHeight: `${size}px` }}
      title={title}
    >
      {effective}
    </span>
  );
};
